import { render, staticRenderFns } from "./HelpCenter.vue?vue&type=template&id=1dbac240&scoped=true"
import script from "./HelpCenter.vue?vue&type=script&lang=js"
export * from "./HelpCenter.vue?vue&type=script&lang=js"
import style0 from "./HelpCenter.vue?vue&type=style&index=0&id=1dbac240&prod&lang=less"
import style1 from "./HelpCenter.vue?vue&type=style&index=1&id=1dbac240&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dbac240",
  null
  
)

export default component.exports